import React from 'react';

const MessagesStub = () => (
  <div className="box">
    <article className="message is-warning">
      <div className="message-header">
        <p>
          <span className="icon">
            <i className="fa fa-commenting" aria-hidden="true"></i>
          </span>
          &nbsp;Сообщения недоступны
        </p>
      </div>
      <div className="message-body">
        <p>
          В феврале 2019 года ВКонтакте закрыл доступ к API сообщений
          для сторонних приложений. Удаление диалогов через StopVK
          больше невозможно.
        </p>
        <br />
        <p>
          Чтобы удалить переписку, воспользуйтесь настройками
          приватности в самом ВКонтакте: <strong>Настройки → Безопасность и конфиденциальность</strong>.
        </p>
      </div>
    </article>
  </div>
);

export default MessagesStub;



// WEBPACK FOOTER //
// ./src/components/MessagesStub.js